import wx from 'weixin-js-sdk'

const wxShare = {
  HTMLDeCode(str)  {
    var    s    =    "";
    if    (str.length    ==    0)    return    "";
    s    =    str.replace(/&amp;/g,    "&");
    s    =    s.replace(/&lt;/g,        " <");
    s    =    s.replace(/&gt;/g,        ">");
    s    =    s.replace(/&nbsp;/g,        "    ");
    s    =    s.replace(/'/g,      "\'");
    s    =    s.replace(/&apos;/g,      "\'");
    s    =    s.replace(/&#39;/g,      "\'");
    s    =    s.replace(/&#039;/g,      "\'");
    s    =    s.replace(/&quot;/g,      "\"");
    return    s;
  },
  wxShareList(options) {
    wx.updateAppMessageShareData({
      title: options.shareTitle, // 分享标题
      desc: options.shareDesc, // 分享描述
      link: options.shareUrl, // 分享链接
      imgUrl: options.shareAvatar, // 分享图标
      type: '', // 分享类型,music、video或link，不填默认为link
      dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
      success: options.shareSuccess,
      cancel: function () {
      }
    });
    wx.updateTimelineShareData({
      title: options.shareTitle, // 分享标题
      link: options.shareUrl, // 分享链接
      imgUrl: options.shareAvatar, // 分享图标
      success: options.shareSuccess,
      cancel: function () {
      }
    });
    wx.onMenuShareWeibo({
      title: options.shareTitle, // 分享标题
      desc: options.shareDesc, // 分享描述
      link: options.shareUrl, // 分享链接
      imgUrl: options.shareAvatar, // 分享图标
      success: options.shareSuccess,
      cancel: function () {
      }
    });
  },
  install(Vue) {
    let _this = this;
    Vue.prototype.setWxConfig = function(options){
      if(!this.$tools.isWeixinClient())
        return;

      if(options.shareTitle){
        options.shareTitle = _this.HTMLDeCode(options.shareTitle);
      }
      if(options.shareDesc){
        options.shareDesc = _this.HTMLDeCode(options.shareDesc);
      }

      let pageUrl = location.href.split('#')[0];
      let qsData = {
        url:pageUrl,
      }
      this.$axios.post('/api/weixinconfig',this.$qs.stringify(qsData)).then(res => {
        let result = res.data;
        let wx_appId = result.appid;
        let wx_timestamp = result.time;
        let wx_nonceStr = result.noncestr;
        let wx_signature = result.signature;

        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: wx_appId, // 必填，公众号的唯一标识
          timestamp: wx_timestamp , // 必填，生成签名的时间戳
          nonceStr: wx_nonceStr, // 必填，生成签名的随机串
          signature: wx_signature,// 必填，签名，见附录1
          jsApiList: [
            'updateAppMessageShareData',
            'updateTimelineShareData',
            'onMenuShareWeibo',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'hideMenuItems'
          ] // 必填，需要使用的JS接口列表
        });

        wx.ready(function(){
          _this.wxShareList(options);
        });
      })
    }
  }
}
export default  wxShare



// WEBPACK FOOTER //
// ./src/assets/js/WeChatShare.js